export default __webpack_public_path__ + "static/media/zm.d0a453b1.svg";